import { NgModule,
         ModuleWithProviders } from '@angular/core';
import { CommonModule }        from '@angular/common';
import { FormsModule, ReactiveFormsModule }         from '@angular/forms';
import { TranslateModule } from 'ng2-translate/ng2-translate';
import { EmailComponent } from './email/email.component';
import { ExpandPanelComponent } from './expand-panel/expandpanel.component';
import { LoadingComponent } from './loading/loading.component';
import { FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe, PartyPipe, SpecialElectionPipe }  from './pipes/electionLevels.pipe';

import { SettingsService } from './settings/settings.service';
import { EventsService } from './Events.service';
import {ElectionService} from './election-service/election.service';

import { AutoNextDirective } from './directives/autoNext.directive';
// import { HttpModule }     from '@angular/http';
// // import { JsonpModule, JSONP_PROVIDERS }     from '@angular/http';
// import { JsonpModule }     from '@angular/http';

@NgModule({
  imports:      [CommonModule,FormsModule,ReactiveFormsModule,TranslateModule.forRoot()],
  declarations: [ EmailComponent,ExpandPanelComponent, LoadingComponent,FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe, PartyPipe, SpecialElectionPipe, AutoNextDirective ],
  exports:      [ CommonModule, FormsModule, TranslateModule,ReactiveFormsModule, EmailComponent, ExpandPanelComponent, LoadingComponent, FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe, PartyPipe, SpecialElectionPipe, AutoNextDirective]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [EventsService,SettingsService, ElectionService ]
    };
  }
}

@NgModule({
  exports:   [ SharedModule ],
  providers: [EventsService,SettingsService, ElectionService ]
})
export class SharedRootModule { }


// WEBPACK FOOTER //
// ./app/shared/shared.module.ts